import { get } from 'lib/httpClient';
import { fetchWithCache } from 'lib/apiCache';

const TABLE_CACHE_KEY = '/tabletype/retrieve';

const retrieve_table_type = async (
  callback: ((data: any) => void) | null = null,
  options: { forceRefresh?: boolean } = {}
): Promise<void> => {
  const { forceRefresh = false } = options;
  const path = TABLE_CACHE_KEY;
  const result = await fetchWithCache(path, () => get(path), forceRefresh);
  console.debug('retrieve_table_type', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { retrieve_table_type };
